<button class="link-content" (click)="toContent()">Hopp til innhold</button>
<nav-bar (drawerToggleEmitter)="toggleDrawer($event)"></nav-bar>
<app-hero itemscope itemprop="primaryImageOfPage"></app-hero>
<main class="wrap" id="main" itemscope itemprop="mainContentOfPage" itemtype="http://schema.org/Blog">
  <router-outlet></router-outlet>
</main>
<app-footer role="contentinfo" itemscope itemtype="https://schema.org/WPFooter"></app-footer>
